import { isValidElement } from 'react';
/**
 * Filters action buttons based on the order type and military exchange flags.
 *
 * @param {ReactNode[]} actionButtons - Array of button components representing action buttons.
 * @param {boolean} guestOrderTrackingRoute - field indicating if user is coming from guest order tracker.
 * @param {boolean} isAAFESOrNexOrder - indicates if the order is from AAFES or NEX user.
 * @param {boolean} enableMilitaryExchangeReturns - FS indicating if returns are enabled for military exchange orders.
 * @returns {ReactNode[]} Filtered outcome of action buttons.
 */
export var parseActionButtons = function (actionButtons, guestOrderTrackingRoute, isAAFESOrNexOrder, enableMilitaryExchangeReturns) {
    if (guestOrderTrackingRoute) {
        // disable all buttons besides Track Shipment+SAR for guest orders that are NOT AAFES/NEX orders
        if (!isAAFESOrNexOrder) {
            return actionButtons.filter(function (button) {
                var _a, _b;
                return (isValidElement(button) && ((_a = button.props) === null || _a === void 0 ? void 0 : _a.name) === 'Track Shipment') ||
                    (isValidElement(button) &&
                        ((_b = button.props) === null || _b === void 0 ? void 0 : _b.name) === 'Start a Return');
            });
        }
        // Remove any return buttons for AAFES/NEX orders if the feature switch is disabled
        if (!enableMilitaryExchangeReturns) {
            return actionButtons.filter(function (button) { var _a; return isValidElement(button) && ((_a = button.props) === null || _a === void 0 ? void 0 : _a.name) !== 'Start a Return'; });
        }
    }
    //   Do not filter any buttons if order is not a guest order
    return actionButtons;
};
